import { EquipmentNameListLabels } from "../common/consts/EquipmentNameList.const";
import { EquipmentUnitListLabels } from "../common/consts/RquipmentUnit.const";
import { WastesChoisesLabels } from "../common/consts/wasteList.const";
import { EquipmentsRecord } from "../interfaces/Equipment.interface";

export const formatEquipmentLabel = (e: EquipmentsRecord) => {
  if (!e) return e;
  const name = EquipmentNameListLabels[e.name] ?? e.name ?? "N/A";
  const unit = e.unit ? EquipmentUnitListLabels[e.unit] ?? e.unit : "";
  const waste = WastesChoisesLabels[e.waste] || e.waste;
  return `${name}${e.size ? " " + e.size : ""}${
    unit ? " " + unit : ""
  } ${waste}`;
};
